<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px;"
      label-position="top"
    >
      <el-form-item
        :label="$l('label_completeDesc') || '确认信息'"
        prop="completeDesc"
      >
        <el-input
          type="textarea"
          v-model="formData.completeDesc"
          maxlength="500"
          :placeholder="$l('tips_completeDesc') || '请输入确认信息'"
          clearable
          rows="4"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="isdelay"
        :label="$l('label_delayDesc') || '延期原因'"
        prop="delayDesc"
        :rules="[
          {
            required: true,
            message: `${$l('label_delayDesc') || '延期原因'}不能为空`,
          },
        ]"
      >
        <el-input
          type="textarea"
          v-model="formData.delayDesc"
          maxlength="500"
          :placeholder="$l('tips_delayDesc') || '项目已延期请输入原因'"
          clearable
          rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    prjCode: {
      default: '',
      type: String,
    },
  },
  watch: {
    // prjCode: {
    //   handler (val) {
    //     console.log('watch', val)
    //     this.formData.prjCode = val
    //   }
    // }
  },
  data() {
    return {
      formData: {
        prjCode: '',
        prjStatus: '',
        completeDesc: '',
        delayDesc: '',
      },
      isdelay: false,
      rules: {
        completeDesc: [
          {
            required: true,
            message: this.$l('tips_completeDesc') || '请输入确认信息',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    // 加载表单数据（完成或终止）
    fromLoad(ref, val) {
      this.init()
      this.formData.prjStatus = val.status
      this.isdelay = val.isdelay
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formData.prjCode = this.prjCode
          this.$api.projectInfoCompleteApi(this.formData).then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('tips_save_ok') || '保存成功！',
              type: 'success',
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
        this.reset()
      }
    },
    reset() {
      this.formData = {
        prjCode: '',
        prjStatus: '',
        completeDesc: '',
        delayDesc: '',
      }
    },
  },
}
</script>
